import { PlanRoute } from '~/data-classes/plan';

export const verifyIfRouteLocked = (route: PlanRoute) => {
    const { isLocked } = route || {};
    return Boolean(isLocked);
};
